import * as R from 'ramda';
import { getIn } from 'formik';
// utilities
import { isArray, isNotNilAndNotEmpty } from './common';
////////////////////////////////////////////////

const checkHasFieldError = (field, errors, touched) => {
  const { required, fieldName } = field;

  const error = getIn(errors, fieldName);
  const touch = getIn(touched, fieldName);

  let hasError;

  if (isArray(touch)) {
    hasError = R.and(isNotNilAndNotEmpty(error), R.or(R.gt(R.length(touch), 0), R.equals(touch, [])));
  } else {
    hasError = R.and(touch, isNotNilAndNotEmpty(error));
  }

  const notificationType = R.and(required, hasError) && 'error';

  return {
    error,
    notificationType,
  };
};

const getFormikProps = props => (
  R.pick(
    [
      'dirty',
      'status',
      'errors',
      'values',
      'touched',
      'isValid',
      'setError',
      'setStatus',
      'setErrors',
      'setValues',
      'resetForm',
      'submitForm',
      'handleBlur',
      'setTouched',
      'handleReset',
      'handleSubmit',
      'handleChange',
      'isSubmitting',
      'validateForm',
      'initialValues',
      'setFieldError',
      'setFieldValue',
      'setSubmitting',
      'validateOnBlur',
      'setFormikState',
      'setFieldTouched',
      'validateOnChange',
    ],
    props,
  )
);

const setInitialFormikValues = (
  defaultValues,
  initialValues,
) => {
  let values = defaultValues;

  if (isNotNilAndNotEmpty(initialValues)) {
    values = R.mergeRight(values, initialValues);
  }

  return values;
};

export {
  getFormikProps,
  checkHasFieldError,
  setInitialFormikValues,
};
